import { Accordion } from '@nextui-org/react';
import { useClaimScoreActionOutputV2TopLevelItems } from './ClaimScoreActionOutputV2Renderer';
import type { ActionOutputV2Payload } from './actionOutputV2Utils';

const NESTED_ACCORDION_CLASS =
    'gap-2 [&_hr]:hidden [&_.divider]:hidden !px-0 min-h-0 [&_[data-slot=content]]:overflow-hidden';
type ClaimIntakeClaimScoreV2PanelProps = Readonly<{
    payload: ActionOutputV2Payload;
    timestamp?: string;
}>;

export function ClaimIntakeClaimScoreV2Panel({ payload, timestamp }: ClaimIntakeClaimScoreV2PanelProps) {
    const { blocks, modal } = useClaimScoreActionOutputV2TopLevelItems({
        data: payload,
        enabled: true,
        activeFilter: null,
        timestamp,
    });

    if (!blocks.length) {
        return <div className="text-sm text-default-500">--</div>;
    }

    return (
        <>
            <Accordion variant="splitted" selectionMode="multiple" isCompact className={NESTED_ACCORDION_CLASS}>
                {blocks}
            </Accordion>
            {modal}
        </>
    );
}
